/**
 * Form validation functions
 */

/**
 * Validate service category
 * @param {Object} category - Category object with name and value
 * @param {boolean} requireValue - If false, only validate name (value auto-generated)
 * @returns {Object} Validation result with isValid and errors
 */
export const validateServiceCategory = ({ name, value }, requireValue = true) => {
  const errors = {}

  if (!name || name.trim() === '') {
    errors.name = 'Le nom est requis'
  }

  if (requireValue) {
    if (!value || value.trim() === '') {
      errors.value = 'La valeur système est requise'
    } else if (!/^[a-zA-Z0-9_]+$/.test(value)) {
      errors.value =
        'La valeur système ne doit contenir que des lettres, chiffres et underscores'
    }
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  }
}

/**
 * Validate custom location
 * @param {Object} location - Location object
 * @returns {Object} Validation result with isValid and errors
 */
export const validateCustomLocation = ({
  name,
  coordinates,
  location_type,
}) => {
  const errors = {}

  if (!name || name.trim() === '') {
    errors.name = 'Le nom est requis'
  }

  if (!coordinates) {
    errors.coordinates = 'Veuillez sélectionner un emplacement sur la carte'
  }

  if (!location_type) {
    errors.location_type = "Le type d'emplacement est requis"
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  }
}

/**
 * Validate task form data
 * @param {Object} taskData - Task form data
 * @returns {Object} Validation result with isValid, errors, and errorMessage
 */
export const validateTaskForm = ({
  selectedService,
  selectedSlope,
  executionDate,
  markerPosition,
}) => {
  const errors = {}

  if (!selectedService) {
    errors.selectedService = 'Le service est requis'
  }

  if (!selectedSlope) {
    errors.selectedSlope = "L'emplacement est requis"
  }

  if (!executionDate) {
    errors.executionDate = "La date d'exécution est requise"
  }

  if (!markerPosition) {
    errors.markerPosition = 'Veuillez placer un marqueur sur la carte'
  }


  // Create a readable error message for displaying in UI
  let errorMessage = ''
  if (Object.keys(errors).length > 0) {
    if (errors.description) {
      errorMessage = errors.description
    } else {
      errorMessage =
        'Veuillez remplir tous les champs obligatoires et placer un marqueur sur la carte'
    }
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
    errorMessage,
  }
}
